var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurrencyIcon = function SvgCurrencyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currency-dollar-mediun-circle 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 7.5V8.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 16.5V15.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.8587 14.2499C10.052 14.6466 10.3586 14.9772 10.7398 15.1997C11.1209 15.4222 11.5595 15.5266 12 15.4999C12.5289 15.5576 13.0595 15.4073 13.4795 15.0806C13.8994 14.754 14.1758 14.2767 14.25 13.7499C14.25 13.3833 14.123 13.028 13.8906 12.7445C13.6582 12.4611 13.3347 12.2668 12.9753 12.1949L11.0247 11.8048C10.6653 11.7329 10.3418 11.5387 10.1094 11.2552C9.87701 10.9717 9.75 10.6165 9.75 10.2499C9.82423 9.72306 10.1006 9.2458 10.5205 8.91916C10.9405 8.59253 11.4711 8.44216 12 8.49989C12.4405 8.47314 12.8791 8.57762 13.2602 8.80011C13.6414 9.02261 13.948 9.35314 14.1413 9.74989",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurrencyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "9233faf889fab684bfbffd3663186bdd.svg";